module.exports = __webpack_public_path__ + "img/mbicon.b02b90b6.svg";